import React from "react";
import moment from "moment";
import parse from "html-react-parser";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Image } from "../../atoms";
import { IconBackMerah } from "../../../assets";
import Context from "../../../context";

const StyledCardItem = styled(Link)`
  text-decoration: none;
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const StyledBadgeCard = styled.div`
  position: absolute;
  width: 50px;
  height: 50px;
  background-color: #e3232a;
  top: 0;
  left: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const WrapMore = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1rem;
`;

const useStyles = makeStyles({
  subTitle: {
    color: "rgba(0,0,0,0.4) !important",
    fontSize: "14px !important",
    lineHeight: "1.5em",
    height: "4.5em",
    overflow: "hidden",
    "& p, & p span": {
      fontSize: "14px !important",
      color: "rgba(0,0,0,0.3) !important",
    },
  },
});

type CardBeritaProps = {
  url: string;
  data: any;
};

const CardBerita = ({ url, data }: CardBeritaProps) => {
  const classes = useStyles();
  const { title_id, title_en, content_id, content_en, image, created_at } =
    data;
  const context = React.useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === "ID" ? true : false;
  return (
    <StyledCardItem to={{ pathname: url, state: data }}>
      <StyledBadgeCard>
        <Typography variant="h5" style={{ color: "white" }}>
          {moment(created_at).format("DD")}
        </Typography>
        <Typography
          variant="caption"
          style={{ color: "white", fontSize: 10, fontWeight: 600 }}
        >
          {moment(created_at).format("MMM YYYY")}
        </Typography>
      </StyledBadgeCard>
      <Image
        height={150}
        src={`${process.env.REACT_APP_URL}/images/${image}`}
      />
      <Typography color="textPrimary" style={{ marginTop: "1rem" }}>
        {isId ? title_id : title_en}
      </Typography>
      <div id="content" className={classes.subTitle}>
        {parse(isId ? content_id : content_en)}
      </div>
      <WrapMore>
        <Typography
          color="textPrimary"
          variant="overline"
          style={{ marginRight: "0.5rem" }}
        >
          {isId ? "Selengkapnya" : "More"}
        </Typography>
        <IconBackMerah />
      </WrapMore>
    </StyledCardItem>
  );
};

export default CardBerita;
